import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline-vertical',
  templateUrl: './timeline-vertical.component.html',
  styleUrls: ['./timeline-vertical.component.css']
})
export class TimelineVerticalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
